// extracted by mini-css-extract-plugin
module.exports = {"autoOrderStatusInfo":"autoOrderMessage_autoOrderStatusInfo__s2DR0"};